import { code } from "@streamdown/code";
import { memo } from "react";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import {
  type ControlsConfig,
  type LinkSafetyConfig,
  Streamdown,
} from "streamdown";

export type MarkdownProps = {
  children?: string;
  id?: string;
  className?: string;
  isAnimating?: boolean;
  controls?: ControlsConfig;
  lineNumbers?: boolean;
  /**
   * Streamdown confirms external links in a dialog by default, rendering them
   * as buttons that need client-side JavaScript. Pass `{ enabled: false }` for
   * plain anchors, e.g. when the markdown is rendered to static HTML.
   */
  linkSafety?: LinkSafetyConfig;
};

const remarkPlugins = [remarkGfm, remarkBreaks];

function MarkdownComponent({
  children,
  id,
  className,
  isAnimating = false,
  controls,
  lineNumbers,
  linkSafety,
}: MarkdownProps) {
  return (
    <div className={className} data-slot="markdown" id={id}>
      <Streamdown
        controls={controls}
        isAnimating={isAnimating}
        lineNumbers={lineNumbers}
        linkSafety={linkSafety}
        plugins={{ code }}
        remarkPlugins={remarkPlugins}
        shikiTheme={["github-light", "github-dark"]}
      >
        {children ?? ""}
      </Streamdown>
    </div>
  );
}

const Markdown = memo(MarkdownComponent);
Markdown.displayName = "Markdown";

export { Markdown };
